import PageHeader from 'components/global/PageHeader';

const DemoLoginTitle = () => {
  return <PageHeader title="Log In to ECHO Knowledge" />;
};

export default DemoLoginTitle;
